import { auth as types } from '../../constants/types'
const auth = {
    login: {},
    loading: false,
    error: null,
    message: null,
    isLoggedIn: !!localStorage.getItem('AUTHORIZATION_TOKEN_BLOG'),
}
const reducer = (state = auth, action) => {
    switch (action.type) {
        case types.LOGIN: return { ...state, login: action.payload };
        case types.LOADING: return { ...state, loading: !state.loading };
        case types.ERROR: return { ...state, error: action.payload };
        case types.LOGGED_IN: return { ...state, isLoggedIn : true };
        case types.LOGGED_OUT: return { ...state, isLoggedIn : false };
        case types.FORGOT_PASSWORD_REQUEST: return { ...state, loading: true, error: null, message: null };
        case types.FORGOT_PASSWORD_SUCCESS: return { ...state, loading: false, message: action.payload };
        case types.FORGOT_PASSWORD_FAILURE: return { ...state, loading: false, error: action.payload };
        default: return state;
    }
};
export default reducer